import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {addMessage} from "../../redux/slices/userMessageSlice";
import {IPostDocumentResponseDto} from "../../dtos/documents/IPostDocumentResponseDto";
import {setIsDetailViewOpen} from "../../redux/slices/modalAsTabSlice";
import {useAppDispatch, useAppSelector} from "../../redux/hooks/hooks";
import {LoadPanel} from "devextreme-react";
import {DocumentSaveActionType} from "../../helpers/DocumentHelper";
import {removeTab} from "../../redux/slices/newTabSlice";
import {setGridUpdateTrigger} from "../../redux/slices/gridSlice";

interface IProps {
    entity: any;
    baseObject?: any;
    // createBaseAtDocumentEntity?: any
    onClose: (result: boolean) => void;
    id?: string;
    clonedObject?: any;
    parentId?: any;
    onDataLoad?: any;
    setUpdatedData?: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export interface INewDocumentModalViewContextProps {
    saveHandler: (newModel: any, action: DocumentSaveActionType) => Promise<void>;
    postHandler: (action: DocumentSaveActionType) => Promise<void>;
    closeHandler: () => void;
    cancelHandler: () => Promise<void>;
}

export const NewDocumentModalViewContext =
    React.createContext<INewDocumentModalViewContextProps>({
        saveHandler: async () => {
        },
        postHandler: async () => {
        },
        closeHandler: () => {
        },
        cancelHandler: async () => {
        },
    });

export const NewDocumentModalView = ({
                                         id,
                                         entity,
                                         onClose,
                                         clonedObject,
                                         baseObject,
                                         onDataLoad,
                                         setUpdatedData,
                                     }: IProps) => {
    const [model, setModel] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [isFailure, setIsFailure] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const dispatch = useAppDispatch();
    const activeTab = useAppSelector((state: any) => state.newTab.activeTab);

    const loadModel = async (id?: string) => {
        console.log("loadModel", id);
        if (!id && !baseObject) {
            setModel(entity.getEmptyModel());
            return;
        }
        if (!id && baseObject) {
            setModel({...baseObject, id: undefined});
            return;
        }

        if (clonedObject) {
            setModel({...clonedObject, id: undefined});
            return;
        }

        try {
            setIsLoading(true);
            setIsFailure(false);
            setErrorMessage(null);
            const dataService = entity.getDataService();
            setModel(await dataService.Get(id));
        } catch (e: any) {
            setIsFailure(true);
            setErrorMessage(e.message);
            toast.error(e.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadModel(id);
    }, [id]);

    const handleSave = async (newModel: any, action: DocumentSaveActionType) => {
        setModel(newModel);
        const dataService = entity.getDataService();
        try {
            setIsSubmitting(true);
            setIsFailure(false);
            setErrorMessage(null);
            if (id && !clonedObject) {
                await dataService.Update(newModel);
                // if (leftTabs.length > 0 && rightTabs.length === 0) {
                //     const activeTab = leftTabs.find((tab: any) => tab.id === activeTabId);
                //     handleTabClose(activeTab);
                // } else {
                //     if (entity.pluralTitle === leftTabs[0]?.tabTitle) {
                //         const activeTab = leftTabs.find(
                //             (tab: any) => tab.id === activeTabId
                //         );
                //         handleTabClose(activeTab);
                //     }
                //     if (entity.pluralTitle === rightTabs[0]?.tabTitle) {
                //         const activeTab = rightTabs.find(
                //             (tab: any) => tab.id === activeTabId
                //         );
                //         handleTabClose(activeTab);
                //     }
                // }
                // dispatch(setIsDetailViewOpen(false));
                // dispatch(setPreviousTabActive());
                // dispatch(setGridUpdateTrigger());
                // dispatch(setFieldChanged({docId: activeTabId, hasChanged: false}));
                toast.success("Saved successfully");
            } else {
                await dataService.Create(newModel);
            }
        } catch (e: any) {
            console.log("handleSave failure");
            console.log(e.message);
            setIsFailure(true);
            setErrorMessage(e.message);
            console.log(e.message);
            toast.error(e.message);
        } finally {
            setIsSubmitting(false);
        }
        // All messages about document or catalogs states should came from server
        // dispatch(
        //   addMessage({
        //     message: "Saved successfully",
        //     type: "success",
        //     date: new Date(),
        //     markedAsRead: false,
        //   })
        // );

        if (action === "save") {
            onClose(false);
            dispatch(setIsDetailViewOpen(false));
            dispatch(removeTab(activeTab));
        }

        // dispatch(setPreviousTabActive());
    };

    function handleClose() {
        onClose(false);
    }

    const modelUpdated = (newModel: any) => {
        setModel(newModel);
    };

    const handlePost = async (action: DocumentSaveActionType) => {
        if (!id) {
            toast.warning("Document is not saved yet");
            return;
        }
        const dataService = entity.getDataService();

        try {
            setIsSubmitting(true);
            setIsFailure(false);
            setErrorMessage(null);

            const responseDto: IPostDocumentResponseDto =
                await dataService.PostDocument(id);
            if (responseDto.success) {
                toast.success("Posted successfully");
                // if (leftTabs.length > 0 && rightTabs.length === 0) {
                //     const activeTab = leftTabs.find((tab: any) => tab.id === activeTabId);
                //     handleTabClose(activeTab);
                // } else {
                //     if (entity.pluralTitle === leftTabs[0]?.tabTitle) {
                //         const activeTab = leftTabs.find(
                //             (tab: any) => tab.id === activeTabId
                //         );
                //         handleTabClose(activeTab);
                //     }
                //     if (entity.pluralTitle === rightTabs[0]?.tabTitle) {
                //         const activeTab = rightTabs.find(
                //             (tab: any) => tab.id === activeTabId
                //         );
                //         handleTabClose(activeTab);
                //     }
                // }
                dispatch(setGridUpdateTrigger());
                // dispatch(setFieldChanged({docId: activeTabId, hasChanged: false}));
                // console.log(3)
            } else {
                toast.error("Posting failed");
                responseDto.validationErrors.forEach((error: string) => {
                    dispatch(
                        addMessage({
                            message: error,
                            type: "error",
                            date: new Date(),
                            markedAsRead: false,
                        })
                    );
                });
            }
        } catch (e: any) {
            toast.error("Posting failed");
            setIsFailure(true);
            setErrorMessage("test");
            console.log(e.message);
        } finally {
            setIsSubmitting(false);
        }
        if (action === "post") {
            onClose(true);
            dispatch(setIsDetailViewOpen(false));
            dispatch(removeTab(activeTab));
        }
    };

    const handleCancel = async () => {
        if (!id) {
            toast.warning("Document is not saved yet");
            return;
        }

        const dataService = entity.getDataService();
        try {
            setIsSubmitting(true);
            setIsFailure(false);
            setErrorMessage(null);
            await dataService.CancelDocument(id);
            dispatch(setGridUpdateTrigger());
            onClose(true);
            dispatch(setIsDetailViewOpen(false));
            dispatch(removeTab(activeTab));            
            toast.success("Canceled successfully");
        } catch (e: any) {
            setIsFailure(true);
            setErrorMessage(e.message);
            toast.error(e.message);
        } finally {
            setIsSubmitting(false);
        }

        onClose(false);
    };

    const getLoadingPanelMessage = () => {
        if (isSubmitting) {
            return "Submitting data...";
        }
        if (isLoading) {
            return "Loading...";
        }
        return "Working...";
    };

    return (
        <>
            <div
                className={"container-fluid"}
                id={"document-detail-view-panel"}
            >
                <div className={"card card-body border"}>
                    <NewDocumentModalViewContext.Provider
                        value={{
                            saveHandler: handleSave,
                            postHandler: handlePost,
                            closeHandler: handleClose,
                            cancelHandler: handleCancel,
                        }}
                    >

                        <>{entity.getDetailViewComponent(model, modelUpdated)} </>
                    </NewDocumentModalViewContext.Provider>
                </div>
            </div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.1)"
                visible={isLoading || isSubmitting}
                showIndicator={true}
                showPane={true}
                shading={true}
                message={getLoadingPanelMessage()}
            />
        </>
    );
};
